// Kiosk copy — Urdu first, English second. Plain language, short sentences, no medical jargon.
// Final wording is reviewed with the Department's health-education team before go-live.

export type Lang = 'ur' | 'en';

const ur = {
  appName: 'صحت کیوسک',
  welcomeTitle: 'خوش آمدید',
  welcomeBody: 'چند منٹ میں اپنا بلڈ پریشر، آکسیجن، درجہ حرارت، قد اور وزن چیک کریں — اور ضرورت ہو تو ڈاکٹر سے بات کریں۔',
  chooseLanguage: 'زبان منتخب کریں',
  start: 'شروع کریں',
  staffAssist: 'عملہ مدد کر رہا ہے',
  staffAssistOn: 'عملے کی مدد والا طریقہ',
  voiceOn: 'آواز: آن',
  voiceOff: 'آواز: بند',
  back: 'واپس',
  next: 'آگے',
  skip: 'چھوڑ دیں',
  cancel: 'ختم کریں',
  yes: 'جی ہاں',
  no: 'نہیں',
  identifyTitle: 'اپنی شناخت کروائیں',
  identifyBody: 'شناختی کارڈ نمبر لکھیں، کارڈ لگائیں یا پرچی کا QR کوڈ اسکین کریں۔',
  byCnic: 'شناختی کارڈ نمبر',
  byCard: 'مریض کارڈ لگائیں',
  byQr: 'QR کوڈ اسکین کریں',
  asGuest: 'شناخت کے بغیر جاری رکھیں',
  enterCnic: 'شناختی کارڈ کے 13 ہندسے لکھیں',
  cnicInvalid: 'شناختی کارڈ نمبر میں 13 ہندسے ہونے چاہئیں',
  tapCard: 'اپنا کارڈ ریڈر پر رکھیں',
  scanQr: 'پرچی کا QR کوڈ اسکینر کے سامنے رکھیں',
  visitCode: 'وزٹ کوڈ',
  lookingUp: 'تلاش ہو رہی ہے…',
  isThisYou: 'کیا یہ آپ ہیں؟',
  newPatient: 'نئے مریض کی معلومات',
  nameOptional: 'نام (اختیاری)',
  sex: 'جنس',
  female: 'خاتون',
  male: 'مرد',
  other: 'دیگر',
  birthYear: 'پیدائش کا سال',
  phoneOptional: 'موبائل نمبر (واٹس ایپ کے لیے، اختیاری)',
  offlineIdentify: 'نیٹ ورک دستیاب نہیں۔ آپ کا ریکارڈ بعد میں ملا دیا جائے گا۔',
  consentTitle: 'آپ کی اجازت',
  consentCare: 'میں اجازت دیتا/دیتی ہوں کہ میری پیمائشیں محفوظ کی جائیں اور میرے علاج کے لیے محکمہ صحت کے عملے اور ڈاکٹر کو دکھائی جائیں۔',
  consentCareNote: 'یہ معائنے کے لیے ضروری ہے۔ آپ کا ڈیٹا محکمہ صحت کی ملکیت ہے اور محفوظ رکھا جاتا ہے۔',
  consentWhatsapp: 'مجھے واٹس ایپ پر یاد دہانی اور فالو اپ پیغامات بھیجے جائیں۔',
  consentResearch: 'میرا ڈیٹا، میرے نام کے بغیر، صحت کی منصوبہ بندی کے لیے استعمال ہو سکتا ہے۔',
  agree: 'میں متفق ہوں',
  decline: 'میں متفق نہیں',
  declinedTitle: 'کوئی بات نہیں',
  declinedBody: 'اجازت کے بغیر معائنہ نہیں ہو سکتا۔ عملہ آپ کی مدد کرے گا۔',
  readinessTitle: 'مشین تیار کی جا رہی ہے',
  checkNetwork: 'نیٹ ورک',
  checkSensors: 'پیمائش کے آلات',
  checkPrinter: 'پرنٹر کا کاغذ',
  networkOffline: 'آف لائن — معائنہ جاری رہے گا، ڈیٹا بعد میں بھیجا جائے گا',
  measureTitle: 'پیمائش',
  measureStart: 'پیمائش شروع کریں',
  tryAgain: 'دوبارہ کوشش کریں',
  measuring: 'پیمائش ہو رہی ہے… ہلیں نہیں',
  repeatReading: 'پیمائش واضح نہیں آئی۔ براہ کرم دوبارہ کریں۔',
  escalateReading: 'پیمائش نہیں ہو سکی۔ عملہ آپ کی مدد کرے گا۔',
  implausible: 'پیمائش درست نہیں لگتی۔ دوبارہ کوشش کریں۔',
  accepted: 'پیمائش محفوظ ہو گئی',
  attempt: 'کوشش',
  deviceUnavailable: 'یہ آلہ اس وقت دستیاب نہیں',
  bodyTitle: 'قد اور وزن',
  bodyHow: 'جوتے اتار کر پلیٹ فارم پر سیدھے کھڑے ہوں۔ سر سیدھا رکھیں۔',
  bpTitle: 'بلڈ پریشر',
  bpHow: 'آرام سے بیٹھیں، پاؤں زمین پر رکھیں۔ بائیں بازو پر کف باندھیں اور بازو دل کی سطح پر رکھیں۔ بات نہ کریں۔',
  oxTitle: 'آکسیجن اور نبض',
  oxHow: 'شہادت کی انگلی کلپ میں ڈالیں اور ہاتھ ساکن رکھیں۔ انگلی پر نیل پالش یا مہندی نہ ہو۔',
  tempTitle: 'درجہ حرارت',
  tempHow: 'ماتھے کو تھرمامیٹر کے سامنے رکھیں۔',
  symptomsTitle: 'آج آپ کو کیا تکلیف ہے؟',
  symptomsBody: 'نیچے سے منتخب کریں یا اپنے الفاظ میں لکھیں / بولیں۔',
  speakNow: 'بولیں',
  listening: 'سن رہا ہے…',
  noSymptoms: 'کوئی تکلیف نہیں',
  understood: 'ہم نے یہ سمجھا',
  typeHere: 'یہاں لکھیں…',
  reviewTitle: 'آپ کی پیمائشیں',
  reviewNote: 'یہ صرف پیمائشیں ہیں، تشخیص نہیں۔ ڈاکٹر یا عملہ آپ کی رہنمائی کرے گا۔',
  routeUrgentTitle: 'براہ کرم یہیں رکیں',
  routeUrgentBody: 'آپ کی کچھ پیمائشوں پر فوری توجہ کی ضرورت ہے۔ عملے کو اطلاع دے دی گئی ہے اور وہ ابھی آ رہے ہیں۔',
  staffConfirm: 'عملہ: مریض کو دیکھ لیا (پن)',
  routeConsultTitle: 'ڈاکٹر سے مشورہ تجویز کیا جاتا ہے',
  routeConsultBody: 'آپ کی پیمائشیں ڈاکٹر کو بھیج دی جائیں گی۔ آپ یہیں ویڈیو پر بات کر سکتے ہیں۔',
  routeQueueTitle: 'آپ کی پیمائشیں معمول کے مطابق ہیں',
  routeQueueBody: 'اپنی پرچی لیں۔ اگر کوئی تکلیف ہے تو آپ ڈاکٹر سے بھی بات کر سکتے ہیں۔',
  talkVideo: 'ڈاکٹر سے ویڈیو پر بات کریں',
  talkAudio: 'صرف آواز پر بات کریں',
  joinQueue: 'قطار میں شامل ہوں',
  printSummary: 'پرچی پرنٹ کریں',
  printing: 'پرچی پرنٹ ہو رہی ہے…',
  takeReceipt: 'اپنی پرچی لے لیں',
  consultWaiting: 'ڈاکٹر جلد آپ سے رابطہ کریں گے',
  consultWaitingBody: 'براہ کرم کیوسک کے سامنے رہیں۔ ڈاکٹر نے آپ کی پیمائشیں پہلے ہی دیکھ لی ہوں گی۔',
  consultOffline: 'نیٹ ورک کمزور ہے۔ آپ کی معلومات ڈاکٹر کو بھیج دی گئی ہیں، جواب واٹس ایپ یا عملے کے ذریعے ملے گا۔',
  consultConnected: 'ڈاکٹر سے رابطہ ہو گیا',
  switchAudio: 'صرف آواز',
  switchChat: 'لکھ کر بات کریں',
  switchVideo: 'ویڈیو',
  send: 'بھیجیں',
  consultDone: 'مشورہ مکمل ہو گیا',
  prescription: 'نسخہ',
  followUp: 'دوبارہ معائنہ',
  days: 'دن بعد',
  printPrescription: 'نسخہ پرنٹ کریں',
  doneTitle: 'شکریہ!',
  doneBody: 'اپنی پرچی ساتھ رکھیں۔ اگلی بار پرچی کا QR کوڈ اسکین کر کے آسانی سے شروع کریں۔',
  resetIn: 'سیکنڈ میں اسکرین صاف ہو جائے گی',
  stillThere: 'کیا آپ ابھی موجود ہیں؟',
  continue: 'جاری رکھیں',
  endSession: 'ختم کریں',
  offlineBadge: 'آف لائن',
  queued: 'بھیجنا باقی',
  receiptTitle: 'صحت معائنہ — خلاصہ',
  receiptNext: 'اگلا قدم',
  receiptNextUrgent: 'فوری طور پر عملے سے ملیں',
  receiptNextConsult: 'ڈاکٹر سے مشورہ',
  receiptNextQueue: 'معمول کی قطار / ضرورت پر ڈاکٹر',
  receiptFooter: 'یہ پرچی تشخیص نہیں ہے۔ محکمہ صحت، حکومت آزاد جموں و کشمیر',
  progress: ['شناخت', 'اجازت', 'تیاری', 'پیمائش', 'تکلیف', 'نتیجہ', 'اگلا قدم'],
};

const en: typeof ur = {
  appName: 'Health Kiosk',
  welcomeTitle: 'Welcome',
  welcomeBody: 'Check your blood pressure, oxygen, temperature, height and weight in a few minutes — and talk to a doctor if you need to.',
  chooseLanguage: 'Choose language',
  start: 'Start',
  staffAssist: 'Staff is helping',
  staffAssistOn: 'Staff-assist mode',
  voiceOn: 'Voice: on',
  voiceOff: 'Voice: off',
  back: 'Back',
  next: 'Next',
  skip: 'Skip',
  cancel: 'Cancel',
  yes: 'Yes',
  no: 'No',
  identifyTitle: 'Identify yourself',
  identifyBody: 'Enter your CNIC, tap your patient card, or scan the QR code on a previous slip.',
  byCnic: 'CNIC number',
  byCard: 'Tap patient card',
  byQr: 'Scan QR code',
  asGuest: 'Continue without ID',
  enterCnic: 'Enter the 13 digits of your CNIC',
  cnicInvalid: 'A CNIC has 13 digits',
  tapCard: 'Place your card on the reader',
  scanQr: 'Hold the slip’s QR code in front of the scanner',
  visitCode: 'Visit code',
  lookingUp: 'Looking up…',
  isThisYou: 'Is this you?',
  newPatient: 'New patient details',
  nameOptional: 'Name (optional)',
  sex: 'Sex',
  female: 'Female',
  male: 'Male',
  other: 'Other',
  birthYear: 'Year of birth',
  phoneOptional: 'Mobile number (for WhatsApp, optional)',
  offlineIdentify: 'No network. Your record will be matched when the kiosk reconnects.',
  consentTitle: 'Your permission',
  consentCare: 'I agree that my measurements are recorded and shown to Health Department staff and doctors for my care.',
  consentCareNote: 'Required for a screening. Your data is owned by the Health Department and kept secure.',
  consentWhatsapp: 'Send me reminders and follow-up messages on WhatsApp.',
  consentResearch: 'My data may be used without my name for health planning.',
  agree: 'I agree',
  decline: 'I do not agree',
  declinedTitle: 'That is fine',
  declinedBody: 'A screening cannot be done without permission. A staff member will help you.',
  readinessTitle: 'Preparing the kiosk',
  checkNetwork: 'Network',
  checkSensors: 'Measuring devices',
  checkPrinter: 'Printer paper',
  networkOffline: 'Offline — the screening continues and data is sent later',
  measureTitle: 'Measurements',
  measureStart: 'Start measurement',
  tryAgain: 'Try again',
  measuring: 'Measuring… please keep still',
  repeatReading: 'The reading was not clear. Please try again.',
  escalateReading: 'The reading could not be taken. A staff member will help you.',
  implausible: 'That reading does not look right. Please try again.',
  accepted: 'Reading saved',
  attempt: 'Attempt',
  deviceUnavailable: 'This device is not available right now',
  bodyTitle: 'Height and weight',
  bodyHow: 'Remove your shoes and stand straight on the platform. Keep your head level.',
  bpTitle: 'Blood pressure',
  bpHow: 'Sit comfortably with feet flat. Put the cuff on your left arm at heart level. Do not talk.',
  oxTitle: 'Oxygen and pulse',
  oxHow: 'Put your index finger in the clip and keep your hand still. No nail polish or henna on that finger.',
  tempTitle: 'Temperature',
  tempHow: 'Hold your forehead in front of the thermometer.',
  symptomsTitle: 'What is troubling you today?',
  symptomsBody: 'Choose below, or type / speak in your own words.',
  speakNow: 'Speak',
  listening: 'Listening…',
  noSymptoms: 'No complaints',
  understood: 'What we understood',
  typeHere: 'Type here…',
  reviewTitle: 'Your measurements',
  reviewNote: 'These are measurements, not a diagnosis. A doctor or staff member will guide you.',
  routeUrgentTitle: 'Please stay here',
  routeUrgentBody: 'Some of your readings need prompt attention. Staff have been alerted and are on their way.',
  staffConfirm: 'Staff: patient seen (PIN)',
  routeConsultTitle: 'A doctor consultation is recommended',
  routeConsultBody: 'Your readings will be sent to the doctor. You can talk on video right here.',
  routeQueueTitle: 'Your readings are within the usual range',
  routeQueueBody: 'Take your slip. If something is troubling you, you can still talk to a doctor.',
  talkVideo: 'Talk to a doctor on video',
  talkAudio: 'Audio only',
  joinQueue: 'Join the queue',
  printSummary: 'Print my slip',
  printing: 'Printing your slip…',
  takeReceipt: 'Please take your slip',
  consultWaiting: 'A doctor will be with you shortly',
  consultWaitingBody: 'Please stay at the kiosk. The doctor will already have your measurements.',
  consultOffline: 'The network is weak. Your details were sent to the doctor; you will hear back on WhatsApp or through staff.',
  consultConnected: 'Connected to the doctor',
  switchAudio: 'Audio only',
  switchChat: 'Chat',
  switchVideo: 'Video',
  send: 'Send',
  consultDone: 'Consultation complete',
  prescription: 'Prescription',
  followUp: 'Follow-up',
  days: 'days',
  printPrescription: 'Print prescription',
  doneTitle: 'Thank you!',
  doneBody: 'Keep your slip. Next time, scan its QR code to start quickly.',
  resetIn: 'seconds until the screen clears',
  stillThere: 'Are you still there?',
  continue: 'Continue',
  endSession: 'End',
  offlineBadge: 'Offline',
  queued: 'queued',
  receiptTitle: 'Health screening — summary',
  receiptNext: 'Next step',
  receiptNextUrgent: 'See staff immediately',
  receiptNextConsult: 'Doctor consultation',
  receiptNextQueue: 'Routine queue / doctor if needed',
  receiptFooter: 'This slip is not a diagnosis. Department of Health, Government of AJK',
  progress: ['Identify', 'Consent', 'Ready', 'Measure', 'Symptoms', 'Results', 'Next step'],
};

export const STRINGS = { ur, en };
export type Strings = typeof ur;

/** Quick-pick symptoms (labels map to phrases the intake engine understands). */
export const SYMPTOM_CHIPS: { id: string; ur: string; en: string; phrase: { ur: string; en: string } }[] = [
  { id: 'fever', ur: 'بخار', en: 'Fever', phrase: { ur: 'بخار', en: 'fever' } },
  { id: 'cough', ur: 'کھانسی', en: 'Cough', phrase: { ur: 'کھانسی', en: 'cough' } },
  { id: 'headache', ur: 'سر درد', en: 'Headache', phrase: { ur: 'سر درد', en: 'headache' } },
  { id: 'abdominal_pain', ur: 'پیٹ درد', en: 'Stomach pain', phrase: { ur: 'پیٹ میں درد', en: 'stomach pain' } },
  { id: 'diarrhoea', ur: 'دست', en: 'Diarrhoea', phrase: { ur: 'دست', en: 'diarrhoea' } },
  { id: 'dizziness', ur: 'چکر', en: 'Dizziness', phrase: { ur: 'چکر', en: 'dizziness' } },
  { id: 'fatigue', ur: 'کمزوری', en: 'Weakness', phrase: { ur: 'کمزوری', en: 'weakness' } },
  { id: 'joint_pain', ur: 'جوڑوں کا درد', en: 'Joint pain', phrase: { ur: 'جوڑوں میں درد', en: 'joint pain' } },
  { id: 'chest_pain', ur: 'سینے میں درد', en: 'Chest pain', phrase: { ur: 'سینے میں درد', en: 'chest pain' } },
  { id: 'dyspnoea', ur: 'سانس پھولنا', en: 'Breathlessness', phrase: { ur: 'سانس پھولنا', en: 'shortness of breath' } },
];
